(function () {
  'use strict';

  /* ---------- MENÚ MÓVIL ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  /* ---------- GALERÍA DE PRODUCTO ---------- */
  document.querySelectorAll('[data-galeria]').forEach(function (galeria) {
    var img = galeria.querySelector('[data-galeria-img]');
    galeria.querySelectorAll('[data-galeria-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        galeria.querySelectorAll('[data-galeria-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
        if (img) img.src = thumb.getAttribute('data-full');
      });
    });
  });

  /* ---------- SELECTOR DE CANTIDAD ---------- */
  document.querySelectorAll('.selector-cantidad').forEach(function (qty) {
    var input = qty.querySelector('[data-qty-input]');
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    plus && plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* ---------- SELECTOR DE VARIANTES (conectado a variant.id real) ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var variantsEl = section.parentElement.querySelector('[data-product-variants]') || document.querySelector('[data-product-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }

    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var comparePriceEl = section.querySelector('[data-compare-price]');
    var atcButton = section.querySelector('[data-atc-button]');
    var atcText = section.querySelector('[data-atc-text]');
    var optionGroups = section.querySelectorAll('.opcion-variante');

    function selectedOptions() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.swatch[aria-current="true"]');
        selected.push(active ? active.getAttribute('data-option-value') : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    }

    function updateUI() {
      var variant = findVariant(selectedOptions());
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (atcButton) {
        atcButton.disabled = !variant.available;
        if (atcText) atcText.textContent = variant.available ? 'Añadir a la bolsa' : 'Agotado';
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.swatch').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
          updateUI();
        });
      });
    });
  });

  /* ---------- CARRITO: abrir/cerrar drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');

  function abrirCarrito() {
    drawer && drawer.classList.add('activo');
    overlay && overlay.classList.add('activo');
    renderCart();
  }
  function cerrarCarrito() {
    drawer && drawer.classList.remove('activo');
    overlay && overlay.classList.remove('activo');
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', abrirCarrito);
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', cerrarCarrito);
  });
  overlay && overlay.addEventListener('click', cerrarCarrito);

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  function renderCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var itemsEl = document.querySelector('[data-cart-items]');
        var footerEl = document.querySelector('[data-cart-footer]');
        var countEls = document.querySelectorAll('[data-cart-count]');

        countEls.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });

        if (!itemsEl) return;

        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<div class="carrito-vacio">Tu bolsa está vacía.</div>';
          if (footerEl) footerEl.innerHTML = '';
          return;
        }

        itemsEl.innerHTML = cart.items.map(function (item) {
          return '<div class="carrito-item">' +
            (item.image ? '<img src="' + item.image + '" alt="">' : '') +
            '<div><div class="carrito-item__nombre">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="carrito-item__variante">' + item.variant_title + '</div>' : '') +
            '<div class="carrito-item__precio">' + item.quantity + ' × ' + formatMoney(item.price) + '</div></div></div>';
        }).join('');

        if (footerEl) {
          footerEl.innerHTML = '<div class="carrito-resumen"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
            '<a href="/checkout" class="btn dorado">Finalizar compra</a>';
        }
      });
  }

  /* ---------- AÑADIR AL CARRITO (AJAX) ---------- */
  document.querySelectorAll('.form-producto').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var button = form.querySelector('[data-atc-button]');
      var originalText = button ? button.innerHTML : '';
      if (button) { button.disabled = true; button.innerHTML = '<span>Añadiendo…</span>'; }

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (button) { button.disabled = false; button.innerHTML = originalText; }
          abrirCarrito();
        })
        .catch(function () {
          if (button) { button.disabled = false; button.innerHTML = originalText; }
        });
    });
  });

  /* Refresca el contador del carrito al cargar cualquier página */
  renderCart();
})();
